import React from 'react';

import { LearnMoreButton } from './businessFeatures';

export const FEATURES_CONFIG = [
  {
    id: 'booking',
    title: 'Booking',
    imageUrl: 'images/image-lady-with-dog-using-laptop.jpeg',
    icon: 'OnlineBooking',
    features: [
      {
        id: 'online_booking',
        title: 'Online booking',
        description:
          'List services online and let pet parents book appointments anytime. Choose to accept bookings from everyone or your existing clients only.',
      },
      {
        id: 'appointment_management',
        title: 'Appointment management',
        description:
          'Create, edit, reschedule, or cancel sessions in your calendar. Notify clients about any changes via automated communications.',
      },
      {
        id: 'repeating_appointments',
        title: 'Repeat appointments',
        description:
          'Save time on admin by enabling repeat appointments through your Pata profile. Perfect for regular clients who always book the same services.',
      },
      {
        id: 'parallel_booking',
        title: 'Parallel booking',
        description:
          'Allow several pets to be booked in at the same time with the parallel booking option. Ideal for multi-pet households or group sessions.',
      },
    ],
  },
  {
    id: 'calendar',
    title: 'Calendar',
    icon: 'Calendar',
    imageUrl: 'images/image-laptop-with-calendar-app.png',
    features: [
      {
        id: 'online_booking',
        title: 'Time off',
        description:
          'Set your working hours, block out lunch breaks and annual leave. Your calendar will show clients your availability in live mode.',
      },
      {
        id: 'schedule_padding',
        title: 'Schedule padding',
        description:
          'Need a breather between appointments? Add short breaks between sessions to your calendar, invisible for your clients.',
      },
      {
        id: 'team_shifts',
        title: 'Team shifts',
        description:
          'Create individual profiles and weekly schedules for each team member. Perfect for managing shifts and keeping everyone in sync.',
      },
      {
        id: 'waiting_lists',
        title: 'Waiting lists',
        description:
          'Enable waiting lists to quickly fill available slots and keep your diary running smoothly. No more empty gaps due to late cancellations!',
      },
    ],
  },
  {
    id: 'services',
    title: 'Services',
    icon: 'Catalogue',
    imageUrl: 'images/image-dog-getting-face-trim.jpeg',
    features: [
      {
        id: 'service_details',
        title: 'Service details',
        description:
          'Help clients choose the right service by adding the service type, detailed description, and pricing. Assign a team member to each pet care session.',
      },
      {
        id: 'memberships',
        title: 'Memberships',
        description:
          'Boost bookings by offering services in bundles or special offers, and  encourage multiple session bookings through our Memberships feature.',
      },
      {
        id: 'additional_settings',
        title: 'Additional settings',
        description:
          'Select the pet types you offer services for. Exclude any breeds you do not accept. Adjust service prices based on the information provided by each client.',
      },
    ],
  },
  {
    id: 'marketing',
    title: 'Marketing',
    icon: 'Megaphone',
    imageUrl: 'images/image-groomer-taking-selfie-with-dog.jpeg',
    features: [
      {
        id: 'pata_profile',
        title: 'Pata profile',
        description:
          'Share your business details, upload images of your work, and list your pet care services – all with no need for a separate website.',
      },
      {
        id: 'client_reviews',
        title: 'Client reviews',
        description:
          'Request reviews from clients automatically after each pet care booking. This adds a rating to your Pata profile and builds trust with new clients.',
      },
      {
        id: 'appointment_reminders',
        title: 'Appointment reminders',
        description: 'Set up automated notifications to help ensure your clients never miss an upcoming booking.',
      },
    ],
  },
  {
    id: 'admin',
    title: 'Admin',
    icon: 'Calendar',
    imageUrl: 'images/image-lady-doing-admin-on-sofa-with-dog.jpeg',
    features: [
      {
        id: 'reporting',
        title: 'Reporting',
        description:
          'Sort and filter all your data stored on the platform, including pet care appointments, client information, transactions, and more.',
      },
      {
        id: 'workplaces',
        title: 'Workplaces',
        description:
          'Manage all your workplaces under one profile – whether you run different branches of the same business or offer several types of pet care services.',
      },
    ],
  },
  {
    id: 'clients',
    title: 'Clients',
    icon: 'Client',
    imageUrl: 'images/image-man-with-dog-walking-into-shop.jpeg',
    features: [
      {
        id: 'pet_profile',
        title: 'Pet profile',
        description:
          'Easily review all the important information about each pet, including medical, behavioural,  grooming details or client notes.',
      },
      {
        id: 'client_details',
        title: 'Client details',
        description:
          "Access clients' contact information, link multiple pet profiles to a single owner, and view past transactions or appointment history.",
      },
      {
        id: 'add_clients_info',
        title: 'Add clients info',
        description:
          'Add client information yourself, or simply send a link and invite clients to create their own Pata profile in no time.',
      },
      {
        id: 'learn_more',
        component: () => <LearnMoreButton />,
      },
    ],
  },
  {
    id: 'payments',
    title: 'Payments',
    icon: 'Membership',
    imageUrl: 'images/image-customer-paying-with-card.jpeg',
    features: [
      {
        id: 'online_payments',
        title: 'Online payment option',
        description:
          'Introduce seamless transactions with PataPay and process online payments, offering a quicker and more convenient experience for clients.',
      },
      {
        id: 'upfront_payments',
        title: 'Upfront payments',
        description:
          'Secure deposits in advance to protect against no-shows. Choose between charging a fixed amount or a percentage of the service price.',
      },
      {
        id: 'add_clients_info',
        title: 'PataPay card reader',
        description:
          'Offer secure in-person transactions for your clients and low processing fees for the business with PataPay card reader.',
      },
      {
        id: 'card_on_file',
        title: 'Card on file functionality',
        description:
          'Collect your clients’ payment cards when they book online, securely storing their details for any late cancellation fees in the future.',
      },
    ],
  },
];
